import { DashboardRiskScore } from "../../pages/api/dashboard";
import Link from "next/link";
import { format } from "date-fns";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { da, enUS, nb, sv } from "date-fns/locale";

interface RiskScoresListProps {
  riskScores: DashboardRiskScore[];
}

const localeMap: Record<string, Locale> = {
  da: da,
  en: enUS,
  no: nb,
  sv: sv,
};

export default function RiskScoresList({ riskScores }: RiskScoresListProps) {
  const { t } = useTranslation();
  const router = useRouter();
  const dateLocale = localeMap[router.locale || "en"] || enUS;

  return (
    <div className="card">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h6 className="mb-0">{t("dashboard.latestRiskAssessments")}</h6>
        <Link href="/risk-scores" className="btn btn-sm btn-outline-primary">
          {t("dashboard.seeAll")}
        </Link>
      </div>
      <div className="card-body p-0">
        {riskScores.length === 0 ? (
          <p className="text-muted p-3 mb-0">{t("dashboard.noRiskAssessmentsYet")}</p>
        ) : (
          <div className="table-responsive">
            <table className="table table-hover mb-0">
              <thead className="table-light">
                <tr>
                  <th>{t("patients.email")}</th>
                  <th>{t("dashboard.progress")}</th>
                  <th>{t("dashboard.origin")}</th>
                  <th>{t("patient.date")}</th>
                </tr>
              </thead>
              <tbody>
                {riskScores.map((score) => (
                  <tr key={score.id}>
                    <td>
                      {score.email ? (
                        <span title={score.email}>
                          {score.email.length > 25
                            ? `${score.email.substring(0, 25)}...`
                            : score.email}
                        </span>
                      ) : (
                        <span className="text-muted">{t("dashboard.noEmail")}</span>
                      )}
                    </td>
                    <td>
                      {score.progressStep !== null ? (
                        <span className="badge bg-info">
                          {t("dashboard.step", { number: score.progressStep })}
                        </span>
                      ) : (
                        <span className="text-muted">-</span>
                      )}
                    </td>
                    <td>
                      <span className="badge bg-secondary">{score.origin}</span>
                    </td>
                    <td>
                      <small>
                        {format(
                          new Date(score.createdAt),
                          "dd. MMM yyyy HH:mm",
                          {
                            locale: dateLocale,
                          }
                        )}
                      </small>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}


